import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Checkbox } from 'primereact/checkbox';
import { Column } from 'primereact/column';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { DataTable } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { FileUpload } from 'primereact/fileupload';
import { InputNumber } from 'primereact/inputnumber';
import { InputSwitch } from 'primereact/inputswitch';
import { InputText } from 'primereact/inputtext';
import { Menu } from 'primereact/menu';
import { OverlayPanel } from 'primereact/overlaypanel';
import { Tag } from 'primereact/tag';
import React, { useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';

import classNames from 'classnames';
import { addHours, format } from 'date-fns';
import { BsCloudDownload, BsFile } from 'react-icons/bs';
import {
  FaAngleDown,
  FaCalendarAlt,
  FaCheck,
  FaDollarSign,
  FaFileExcel,
  FaFilePdf,
  FaSearch,
  FaShare,
  FaTimes,
  FaTrash,
  FaUndo,
  FaUndoAlt
} from 'react-icons/fa';
import { GiCog } from 'react-icons/gi';
import { mask, unMask } from 'remask';

import AppCard from '../../../../components/appCard';
import { confirmFooter } from '../../../../components/confirmFooter';
import ExportarParaPDF from '../../../../components/dashboard/adimplencias/boletos/ExportarParaPDF';
import ExportarParaXLS from '../../../../components/dashboard/adimplencias/boletos/ExportarParaXLS';

import { useInfo } from '../../../../context/infoContext';
import { Api, ApiAdimplencia } from '../../../../services/api';
import { associado_id, userInfo } from '../../../../services/authHandlers';

import PreviewBoletoConfirmacao from '../../../../components/dashboard/adimplencias/boletos/PreviewBoletoConfirmacao';
import {
  CalendarPague,
  DropdownPague,
  InputNumberPague,
  LargeTablePague,
  TRANSITIONS
} from '../../../../styles/primeReactConfig';
import { ConvertDateDoMounth } from '../../../../utils/formatCurrency';

/**
 * Lista de boletos com filtros e ações.
 *
 * Observação importante (produção):
 * - Menu deve ser único (não por linha), para evitar race-condition e "ref" compartilhado,
 *   que pode gerar chamadas do tipo /boleto/undefined/pdf.
 */
export const BoletoLista = ({ rowsPerPage }) => {
  const TRES_MB_EM_BYTES = 3145728;

  /** @type {import('react').MutableRefObject<any>} */
  const menuRef = useRef(null);

  /** @type {import('react').MutableRefObject<any>} */
  const op = useRef(null);

  const [mobile, setMobile] = useState(false);
  const [reloading, setReloading] = useState(false);
  const [loading, setLoading] = useState(false);

  // paginação e tabela
  const [first, setFirst] = useState(0);
  const [totalNegotiation, setTotalNegotiation] = useState(0);
  const [negotiationData, setNegotiationData] = useState([]);

  // filtro
  const [selectedFilter, setSelectedFilter] = useState('recebivel');
  const [filterParam, setFilterParam] = useState('');
  const [recebivelTipoId, setRecebivelTipoId] = useState('');
  const [recebivelFilterOptions, setRecebivelFilterOptions] = useState([]);

  const [filterTimeStart, setFilterTimeStart] = useState('');
  const [filterTimeEnd, setFilterTimeEnd] = useState('');
  const [statusParams, setStatusParams] = useState([]);

  const [iconStatus, setIconStatus] = useState(true);

  // Filter Avulso
  const [avulsoTipoId] = useState('');

  // sets Cancela Descrição
  const [cancelaData, setCancelaData] = useState('');
  const [cancelaDescricao, setCancelaDescricao] = useState('');

  // Sets Baixa Manual
  const [baixaDescricao, setBaixaDescricao] = useState('');
  const [valorBaixa, setValorBaixa] = useState('');
  const [listarTipoId, setListarTipoId] = useState('');
  const [baixaDataPagamento, setBaixaDataPagamento] = useState('');
  const [listaTipo, setListaTipo] = useState([]);
  const [baixaManualImagem, setBaixaManualImagem] = useState({});
  const [totalSize, setTotalSize] = useState(0);
  const [boletoData, setBoletoData] = useState(0);

  // Sets Gerar novo Boleto
  const [dataGerarNovoBoleto, setDataGerarNovoBoleto] = useState({});
  const [boletoContrato, setBoletoContrato] = useState('');
  const [boletoContratante, setBoletoContratante] = useState('');
  const [boletoDescricao, setboletoDescricao] = useState('');
  const [boletoValor, setBoletoValor] = useState(0);
  const [boletoDesconto, setBoletoDesconto] = useState(0);
  const [boletoVencido, setBoletoVencido] = useState('');
  const [, setBoletoPago] = useState('');
  const [boletoMulta, setBoletoMulta] = useState(true);
  const [boletoJuros, setBoletoJuros] = useState(true);
  const [boletoVencimento, setBoletoVencimento] = useState('');

  const [rowCurrent, setRowCurrent] = useState(null);

  const [page, setPage] = useState(0);
  const [rows, setRows] = useState(() => {
    if (rowsPerPage) return rowsPerPage[0];
    return 10;
  });
  const [rowsPerPageOptions] = useState(() => {
    if (rowsPerPage) return rowsPerPage;
    return [10, 20, 50];
  });

  const [showExportXLS, setShowExportXLS] = useState(false);
  const [showExportPDF, setShowExportPDF] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showCancel, setShowCancel] = useState(false);
  const [showBaixaManual, setShowBaixaManual] = useState(false);
  const [showGerarNovo, setShowGerarNovo] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [showGerar, setShowGerar] = useState(false);
  const [showDelete, setShowDelete] = useState(false);

  /** Menu único (itens são montados na hora do clique na linha) */
  const [menuItems, setMenuItems] = useState([]);

  const { credorData, detalhesCredor } = useInfo();

  useEffect(() => {
    if (filterParam !== '') Search(page, rows);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reloading]);

  useEffect(() => {
    const { credor_id } = credorData;

    if (credorData === false) return;
    getRecebivelTipos(credor_id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [credorData]);

  useEffect(() => {
    window.addEventListener('resize', ScreenCheck);
    ScreenCheck();

    return () => {
      window.removeEventListener('resize', ScreenCheck);
    };
  }, []);

  /**
   * Resolve o ID do boleto recorrência independentemente do formato do payload.
   *
   * @param {any} row
   * @returns {string|number|null}
   */
  const getBoletoRecorrenciaId = (row) => {
    return row?.boleto_recorrencia_id ?? row?.boletoRecorrenciaId ?? row?.id ?? null;
  };

  /**
   * Monta o menu de ações baseado na linha clicada.
   * Importante: não depender de `rowCurrent` para abrir PDF, pois `setState` é assíncrono.
   *
   * @param {any} row
   * @returns {import('primereact/menu').MenuItem[]}
   */
  const buildMenuItems = (row) => {
    const id = getBoletoRecorrenciaId(row);
    const situacao = row?.boleto_situacao;
    const bloqueado = ['cancelado', 'pago', 'inadimplencia'].includes(situacao);

    const items = [
      {
        label: 'Abrir Boleto',
        icon: <BsCloudDownload className="mr-2" />,
        command: () => abrirBoleto(id)
      },
      {
        label: 'Baixa manual',
        icon: <FaDollarSign className="mr-2" />,
        disabled: bloqueado,
        command: () => {
          setRowCurrent(row);
          setShowBaixaManual(true);
        }
      },
      {
        label: 'Atualizar Boleto',
        icon: <FaUndoAlt className="mr-2" />,
        disabled: bloqueado,
        command: () => {
          setRowCurrent(row);
          setShowGerarNovo(true);
        }
      }
    ];

    if (userInfo.super_usuario) {
      items.push({
        label: situacao !== 'pago' ? 'Cancelar Boleto' : 'Boleto Pago',
        icon: situacao !== 'pago' ? <BsFile className="mr-2" /> : <FaCheck className="mr-2" />,
        disabled: situacao === 'pago',
        command: () => {
          setRowCurrent(row);
          setShowCancel(true);
        }
      });
    }

    return items;
  };

  // =========================
  // chamada de api
  // =========================

  /**
   * Busca boletos conforme filtros.
   *
   * @param {number} pageParam
   * @param {number} rowsParam
   * @param {boolean} resetPagination
   * @returns {Promise<void>}
   */
  const Search = async (pageParam = 0, rowsParam = 10, resetPagination = false) => {
    setLoading(true);
    setNegotiationData([]);

    if (resetPagination) {
      setPage(pageParam);
      setRows(rowsParam);
      setFirst(0);
    }

    if (credorData == false) {
      setLoading(false);
      return;
    }

    // Verifica se o parâmetro do filtro foi preenchido
    if (!filterParam && (!filterTimeStart && !filterTimeEnd)) {
      toast.info('É necessário digitar um valor para o filtro escolhido.');
      setLoading(false);
      return;
    }

    if (selectedFilter === 'recebivel' && !recebivelTipoId) {
      toast.info('É necessário selecionar um tipo para o filtro escolhido.');
      setLoading(false);
      return;
    }

    try {
      const queries = [`limit=${rowsParam}`, `page=${pageParam}`];
      let filtro = '';
      let stringArray = filterParam;

      switch (selectedFilter) {
        case 'documento':
          filtro = selectedFilter;
          stringArray = unMask(filterParam);
          break;
        case 'avulso': {
          filtro = selectedFilter + recebivelTipoId;
          const formatedDateAvulso = await ConvertDateDoMounth(filterParam);
          stringArray = formatedDateAvulso.split('/');
          break;
        }
        case 'mesano':
        case 'recebivel': {
          filtro = selectedFilter;
          const formatedDate = await ConvertDateDoMounth(filterParam);
          stringArray = formatedDate.split('/');
          break;
        }
        case 'nome':
        case 'beneficiario':
        default:
          filtro = selectedFilter;
          break;
      }

      const filtroMes = stringArray?.[0];
      const filtroAno = stringArray?.[1];

      // Construção dos filtros com base no tipo selecionado
      switch (filtro) {
        case 'mesano':
          queries.push(`mes_referencia=${filtroMes}`, `ano_referencia=${filtroAno}`);
          break;
        case 'recebivel':
          queries.push(`recebivel_tipo_id=${recebivelTipoId}`, `mes_referencia=${filtroMes}`, `ano_referencia=${filtroAno}`);
          break;
        case 'avulsoreferencia':
          queries.push(`recebivel_tipo_id=LANCAMENTO`, `mes_referencia=${filtroMes}`, `ano_referencia=${filtroAno}`);
          break;
        case 'avulsovencimento':
          queries.push(`recebivel_tipo_id=LANCAMENTO`, `mes_vencimento=${filtroMes}`, `ano_vencimento=${filtroAno}`);
          break;
        case 'documento':
          queries.push(`usuario_documento=${stringArray}`);
          break;
        case 'nome':
          queries.push(`usuario_nome=${stringArray}`);
          break;
        case 'beneficiario':
          queries.push(`beneficiario=${stringArray}`);
          break;
        case 'vencimento':
          queries.push(
            `vencimento_inicio=${filterTimeStart.toISOString().split('T')[0]}`,
            `vencimento_fim=${filterTimeEnd.toISOString().split('T')[0]}`
          );
          break;
        case 'pagamento':
          queries.push(
            `pagamento_inicio=${filterTimeStart.toISOString().split('T')[0]}`,
            `pagamento_fim=${filterTimeEnd.toISOString().split('T')[0]}`
          );
          break;
        case 'repasse':
          queries.push(
            `repasse_inicio=${filterTimeStart.toISOString().split('T')[0]}`,
            `repasse_fim=${filterTimeEnd.toISOString().split('T')[0]}`
          );
          break;
        default:
          toast.error('Filtro inválido!');
          setLoading(false);
          return;
      }

      // Suporte a múltiplas situações (array separado por vírgula)
      if (statusParams.length > 0) {
        queries.push(`situacao=${statusParams.join(',')}`);
      }

      const { data } = await ApiAdimplencia.get(`/boleto?${queries.join('&')}`);
      setNegotiationData(data.boletos);
      setTotalNegotiation(data.total);
    } catch (err) {
      const status = err?.response?.status;
      if (status === 404) {
        toast.error(err?.response?.data?.mensagem);
        setNegotiationData([]);
        setTotalNegotiation(0);
      } else {
        toast.error('Erro ao buscar boletos.');
      }
    } finally {
      setLoading(false);
    }
  };

  /**
   * Lista tipos de pagamento.
   *
   * @returns {Promise<void>}
   */
  async function listarPagamentoTipo() {
    try {
      const { data } = await Api.get(`/tipopagamento/list`);
      const options = (data ?? []).map((tipo) => ({
        label: tipo.tp_pagamento_nome,
        value: [tipo.tp_pagamento_id, tipo.tp_pagamento_nome]
      }));
      setListaTipo(options);
    } catch (err) {
      setListaTipo([]);
    }
  }

  /**
   * Busca tipos de recebível.
   *
   * @param {string|number} credorId
   * @returns {Promise<boolean>}
   */
  async function getRecebivelTipos(credorId) {
    try {
      const { data } = await ApiAdimplencia.get(`/recebivelTipo/listarTodos/${credorId}`);

      if (data) {
        const totalData = [];
        data.forEach((item) => {
          totalData.push({ label: item.recebivel_tipo_descricao, value: item.recebivel_tipo_id });
        });

        setRecebivelFilterOptions(totalData);
      }

      return true;
    } catch (err) {
      toast.error('Erro de conexão com o servidor, tente novamente mais tarde!');
      return false;
    }
  }

  /**
   * Abre o PDF do boleto.
   *
   * @param {string|number|null} boletoRecorrenciaId
   * @returns {Promise<void>}
   */
  const abrirBoleto = async (boletoRecorrenciaId) => {
    if (!boletoRecorrenciaId) {
      toast.error('Não foi possível abrir: boleto_recorrencia_id não encontrado nesta linha.');
      return;
    }

    const toastId = toast.loading('Aguarde, gerando o boleto...');

    try {
      const { data } = await ApiAdimplencia.get(`/boleto/${boletoRecorrenciaId}/pdf`);

      if (data?.sucesso && data?.dados?.base64_pdf) {
        const base64 = `data:application/pdf;base64,${data.dados.base64_pdf}`;
        const url = URL.createObjectURL(base64toBlob(base64));
        window.open(url);

        toast.update(toastId, {
          render: data.mensagem || 'Boleto aberto com sucesso!',
          type: 'success',
          isLoading: false,
          autoClose: 3000
        });
      } else {
        toast.update(toastId, {
          render: data?.mensagem || 'Não foi possível abrir o boleto.',
          type: 'warning',
          isLoading: false,
          autoClose: 4000
        });
      }
    } catch (error) {
      const mensagem =
        error?.response?.data?.mensagem ||
        error?.message ||
        'Erro inesperado ao abrir o boleto.';

      toast.update(toastId, {
        render: mensagem,
        type: 'error',
        isLoading: false,
        autoClose: 5000
      });
    }
  };

  /**
   * Cancela boleto.
   *
   * @returns {Promise<void>}
   */
  async function cancelaBoleto() {
    setIsLoading(true);
    try {
      const { data } = await ApiAdimplencia.post('/boleto/cancelar', cancelaData);

      if (data) toast.success('Boleto Cancelado com sucesso!');
      atualizaEFecha();
    } catch (error) {
      toast.error('Houve um erro ao tentar cancelar o boleto!');
    } finally {
      setIsLoading(false);
    }
  }

  /**
   * Envia baixa manual.
   *
   * @returns {Promise<void>}
   */
  async function enviarBaixaManual() {
    setIsLoading(true);
    try {
      const { data } = await ApiAdimplencia.post('/boleto/baixa', boletoData);

      if (data) {
        setShowConfirm(false);
        toast.success('Envio concluido com sucesso!');
        atualizaEFecha();
      }
    } catch (error) {
      toast.error('Houve um erro na tentativa de envio.');
    } finally {
      setIsLoading(false);
    }
  }

  /**
   * Gera segunda via (novo boleto).
   *
   * @returns {Promise<void>}
   */
  async function gerarNovoBoleto() {
    setIsLoading(true);
    try {
      await ApiAdimplencia.post('/boleto/segunda-via', dataGerarNovoBoleto);

      toast.success('Boleto criado com sucesso!');
      setShowConfirm(false);
      atualizaEFecha();
    } catch (error) {
      const msg = error?.response?.data?.mensagem || 'Houve um erro ao tentar gerar boleto.';
      toast.error(msg);
      // eslint-disable-next-line no-console
      console.error('Erro ao gerar segunda via:', error);
    } finally {
      setIsLoading(false);
    }
  }

  // =========================
  // function
  // =========================

  /**
   * Faz upload e valida imagem/pdf.
   *
   * @param {any} e
   * @returns {void}
   */
  function uploadImagem(e) {
    const imagemArquivo = e.files[0];
    const limparImagem = e.options.clear;

    if (e.files.length > 1) {
      toast.error('Insira apenas uma imagem');
      limparImagem();
      return;
    }

    if (imagemArquivo.type.indexOf('image/') !== -1) {
      const validType1 = !(imagemArquivo.type.indexOf('png') === -1);
      const validType2 = !(imagemArquivo.type.indexOf('jpeg') === -1);
      const validType3 = !(imagemArquivo.type.indexOf('jpg') === -1);
      const validType4 = !(imagemArquivo.type.indexOf('jpe') === -1);
      if (!(validType1 || validType2 || validType3 || validType4)) {
        if (imagemArquivo.type.indexOf('/pdf') === -1) {
          toast.error('Insira um arquivo de imagem no formato jpeg ou png.');
          limparImagem();
          return;
        }
      }
    } else {
      if (imagemArquivo.type.indexOf('/pdf') === -1) {
        toast.error('Insira um arquivo de imagem ou pdf.');
        limparImagem();
        return;
      }
    }

    const leitor = new FileReader();
    leitor.readAsDataURL(imagemArquivo);

    leitor.onload = function (evt) {
      if (imagemArquivo.type.indexOf('image/') !== -1) {
        const elementoImagem = new Image();
        elementoImagem.src = evt.target.result;

        elementoImagem.onload = function () {
          setBaixaManualImagem(new Blob([imagemArquivo], { type: imagemArquivo.type }));
        };
      } else {
        setBaixaManualImagem(new Blob([imagemArquivo], { type: imagemArquivo.type }));
      }
    };
  }

  /**
   * Valida filtro antes de exportar.
   *
   * @returns {void}
   */
  function verificaFiltro() {
    if (!filterParam && (!filterTimeStart && !filterTimeEnd)) {
      toast.info('É necessário digitar um valor para o filtro escolhido.');
      setLoading(false);
      return;
    }

    if (selectedFilter === 'recebivel' && !recebivelTipoId) {
      toast.info('É necessário selecionar um tipo para o filtro escolhido.');
      setLoading(false);
      return;
    }
  }

  /**
   * Reseta estados e recarrega listagem.
   *
   * @returns {void}
   */
  function atualizaEFecha() {
    setBaixaDescricao('');
    setValorBaixa('');
    setListarTipoId('');
    setBaixaDataPagamento('');
    setBaixaManualImagem({});
    setListaTipo([]);
    setTotalSize(0);
    setBoletoData(0);
    setCancelaData(0);
    setShowBaixaManual(false);
    setShowGerarNovo(false);
    setShowGerar(false);
    setShowCancel(false);
    setShowDelete(false);

    Search(page, rows);
  }

  /**
   * Atualiza filtros de status (checkbox).
   *
   * @param {any} e
   * @returns {void}
   */
  const onStatusChange = (e) => {
    const _statusParams = [...statusParams];

    if (e.checked) _statusParams.push(e.value);
    else _statusParams.splice(_statusParams.indexOf(e.value), 1);

    setStatusParams(_statusParams);
  };

  /**
   * Enter aciona busca.
   *
   * @param {number} keyCode
   * @returns {Promise<void>|void}
   */
  function handleSearch(keyCode) {
    if (keyCode === 13) {
      return Search(0, 10, true);
    }
  }

  /**
   * Paginação.
   *
   * @param {any} event
   * @returns {Promise<void>}
   */
  function onPage(event) {
    const startIndex = parseInt(event.first);
    setRows(event.rows);
    setPage(event.page);
    setFirst(startIndex);

    return Search(event.page, event.rows);
  }

  /**
   * Checa tamanho da tela.
   *
   * @returns {void}
   */
  const ScreenCheck = () => {
    if (window.screen.width <= 480 || window.screen.height <= 480) {
      setMobile(false);
    } else {
      setMobile(true);
    }
  };

  /**
   * Envia baixa manual.
   *
   * @param {React.FormEvent} event
   * @returns {void}
   */
  function handleSubmit(event) {
    event.preventDefault();

    const boletoRecId = getBoletoRecorrenciaId(rowCurrent);
    if (!boletoRecId) {
      toast.error('Não foi possível enviar: boleto_recorrencia_id não encontrado.');
      return;
    }

    const formData = new FormData();

    if (!listarTipoId) {
      toast.info('Escolha uma forma de pagamento.');
      return;
    }

    formData.append('file', baixaManualImagem?.type ? baixaManualImagem : null);
    formData.append(
      'boletoData',
      JSON.stringify({
        baixa_descricao: baixaDescricao,
        valor_total: valorBaixa,
        data_pagamento: format(baixaDataPagamento, 'yyyy-MM-dd'),
        associado_id: associado_id,
        boleto_recorrencia_id: boletoRecId,
        tp_pagamento_id: listarTipoId[0]
      })
    );

    setBoletoData(formData);
    setShowConfirm(true);
  }

  /**
   * Abre confirmação para gerar novo boleto.
   *
   * @param {React.FormEvent} event
   * @returns {void}
   */
  async function handleRenew(event) {
    event.preventDefault();

    const boletoRecId = getBoletoRecorrenciaId(rowCurrent);
    if (!boletoRecId) {
      toast.error('Não foi possível gerar: boleto_recorrencia_id não encontrado.');
      return;
    }

    setDataGerarNovoBoleto({
      boleto_recorrencia_id: boletoRecId,
      novo_vencimento: format(boletoVencimento, 'yyyy-MM-dd'),
      novo_valor: boletoValor !== '' ? parseFloat(boletoValor) : null,
      novo_desconto: boletoDesconto !== '' ? parseFloat(boletoDesconto) : null,
      aplicar_juros: boletoJuros,
      aplicar_multa: boletoMulta
    });

    setShowGerar(true);
  }

  /**
   * Prepara payload de cancelamento e abre confirmação.
   *
   * @param {React.FormEvent} event
   * @returns {void}
   */
  function handleDelete(event) {
    event.preventDefault();

    const boletoRecId = getBoletoRecorrenciaId(rowCurrent);
    if (!boletoRecId) {
      toast.error('Não foi possível cancelar: boleto_recorrencia_id não encontrado.');
      return;
    }

    const infoCancela = {
      boleto_recorrencia_id: boletoRecId,
      motivo_cancelamento: cancelaDescricao
    };

    setCancelaData(infoCancela);
    setShowDelete(true);
  }

  // =========================
  // template / formatação
  // =========================

  const filterParamOptions = [
    { label: 'Mês/Ano', value: 'mesano' },
    { label: 'Produto/Serviço', value: 'recebivel' },
    { label: 'Boleto Avulso', value: 'avulso' },
    { label: 'Documento', value: 'documento' },
    { label: 'Nome', value: 'nome' },
    { label: 'Beneficiario', value: 'beneficiario' },
    { label: 'Vencimento', value: 'vencimento' },
    { label: 'Pagamento', value: 'pagamento' },
    { label: 'Repasse', value: 'repasse' }
  ];

  const filterAvulsoOptions = [
    { label: 'Vencimento', value: 'vencimento' },
    { label: 'Referencia', value: 'referencia' }
  ];

  /**
   * Cabeçalho da tabela.
   */
  const negotiationTableHeader = (
    <div className="flex flex-col items-center">
      <div className="w-full flex justify-between p-2">
        <p className="text-bold text-2xl">Boletos</p>
        <div className="flex flex-row gap-1">
          <Button
            className="h-[3rem]"
            severity="info"
            label="Excel"
            icon={<FaFileExcel />}
            onClick={() => {
              verificaFiltro();
              setShowExportXLS(true);
            }}
            disabled={negotiationData.length !== 0 ? false : true}
          />
          <Button
            className="h-[3rem]"
            severity="info"
            label="PDF"
            icon={<FaFilePdf />}
            onClick={() => {
              verificaFiltro();
              setShowExportPDF(true);
            }}
            disabled={negotiationData.length !== 0 ? false : true}
          />
        </div>
      </div>

      <div className="flex flex-col lg:flex-row justify-between w-full">
        <div className="flex flex-wrap w-full py-4 gap-2">
          <Dropdown
            className="w-full md:w-56 h-fit"
            value={selectedFilter}
            options={filterParamOptions}
            onChange={(e) => {
              setSelectedFilter(e.value);
              setFilterParam('');
              if (!(e.value === 'vencimento' || e.value === 'pagamento' || e.value === 'repasse')) {
                setFilterTimeStart('');
                setFilterTimeEnd('');
              }
              if (e.value === 'recebivel') detalhesCredor();
            }}
            pt={{
              root: ({ props }) => ({
                className: classNames(
                  'cursor-pointer inline-flex relative select-none',
                  'bg-white border border-gray-400 transition-colors duration-200 ease-in-out rounded-md',
                  'dark:bg-gray-900 dark:border-blue-900/40 dark:hover:border-blue-300',
                  'hover:border-blue-500 focus:outline-none focus:outline-offset-0 focus:shadow-[0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[0_0_0_0.2rem_rgba(147,197,253,0.5)]',
                  {
                    'opacity-60 select-none pointer-events-none cursor-default': props.disabled,
                    'w-full md:w-56': !props.className,
                    'lg:w-1/2 w-full': props.className === 'painelAdimplencia',
                    'w-full': props.className === 'parametrosAdimplencia'
                  }
                )
              }),
              filtercontainer: 'relative flex items-center',
              filterinput: {
                className: classNames(
                  'pr-7 -mr-7 ',
                  'w-full',
                  'font-sans text-base text-gray-700 bg-white py-3 px-7 border border-gray-300 transition duration-200 rounded-lg appearance-none',
                  'dark:bg-gray-900 dark:border-blue-900/40 dark:hover:border-blue-300 dark:text-white/80',
                  'hover:border-blue-500 focus:outline-none focus:outline-offset-0 focus:shadow-[0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[0_0_0_0.2rem_rgba(147,197,253,0.5)]'
                )
              },
              filtericon: 'absolute w-auto px-2',
              itemLabel: 'font-semibold',
              item: ({ context }) => ({
                className: classNames(
                  'cursor-pointer font-normal overflow-hidden relative whitespace-nowrap',
                  'm-0 p-3 border-0  transition-shadow duration-200 rounded-none',
                  'dark:text-white/80 dark:hover:bg-gray-700 dark:hover:text-white',
                  'hover:text-gray-900 hover:bg-gray-200 hover:font-bold',
                  {
                    'text-gray-700': !context.focused && !context.selected,
                    'bg-gray-300 text-gray-700 dark:text-white/80 dark:bg-gray-800/90': context.focused && !context.selected,
                    'bg-blue-100 text-blue-700 dark:bg-sky-800 dark:text-white/80': context.focused && context.selected,
                    'bg-blue-50 text-blue-700 dark:bg-sky-700 dark:text-white/80': !context.focused && context.selected,
                    'opacity-60 select-none pointer-events-none cursor-default': context.disabled
                  }
                )
              })
            }}
          />

          {selectedFilter === 'mesano' && (
            <div className="w-full md:w-56">
              <Calendar
                placeholder="Busca por Mês/Ano"
                view="month"
                dateFormat="mm/yy"
                showOnFocus={true}
                className="formularioAdimplencia"
                pt={CalendarPague}
                onKeyDown={(e) => handleSearch(e.keyCode)}
                value={filterParam}
                onChange={(e) => setFilterParam(e.value)}
                yearRange="2000:2030"
                yearNavigator
                showIcon
                icon={
                  <FaCalendarAlt
                    className={classNames(
                      'w-[3rem] h-[3rem] p-3 rounded-r-lg',
                      'bg-sky-400 text-white hover:bg-sky-500',
                      'dark:bg-sky-500 dark:text-black dark:hover:bg-sky-400'
                    )}
                  />
                }
              />
            </div>
          )}

          {(selectedFilter === 'avulso' || selectedFilter === 'recebivel') && (
            <div className="w-full md:w-fit flex flex-wrap gap-1">
              <Dropdown
                className="w-full md:w-56 h-fit"
                pt={DropdownPague}
                value={recebivelTipoId}
                options={selectedFilter === 'recebivel' ? recebivelFilterOptions : filterAvulsoOptions}
                onChange={(e) => {
                  setPage(0);
                  setRecebivelTipoId(e.value);
                }}
              />
              <div className="w-full md:w-56">
                <Calendar
                  className="formularioAdimplencia"
                  pt={CalendarPague}
                  showOnFocus={true}
                  showIcon
                  icon={
                    <FaCalendarAlt
                      className={classNames(
                        'w-[3rem] h-[3rem] p-3 rounded-r-lg',
                        'bg-sky-400 text-white hover:bg-sky-500',
                        'dark:bg-sky-500 dark:text-black dark:hover:bg-sky-400'
                      )}
                    />
                  }
                  yearNavigator
                  yearRange="2000:2030"
                  view="month"
                  dateFormat="mm/yy"
                  onKeyDown={(e) => handleSearch(e.keyCode)}
                  placeholder="Busca por Mês/Ano"
                  value={filterParam}
                  onChange={(e) => setFilterParam(e.value)}
                />
              </div>
            </div>
          )}

          {selectedFilter === 'documento' && (
            <div className="w-full md:w-56">
              <InputText
                value={filterParam}
                onChange={(e) =>
                  setFilterParam(mask(unMask(e.target.value), ['999.999.999-99', '99.999.999/9999-99']))
                }
                placeholder="Busca por documento"
                onKeyDown={(e) => handleSearch(e.keyCode)}
              />
            </div>
          )}

          {selectedFilter === 'nome' && (
            <div className="w-full md:w-56">
              <InputText
                className="w-full"
                value={filterParam}
                onChange={(e) => setFilterParam(e.target.value)}
                placeholder="Nome do Cliente"
                onKeyDown={(e) => handleSearch(e.keyCode)}
              />
            </div>
          )}

          {selectedFilter === 'beneficiario' && (
            <div className="w-full md:w-56">
              <InputText
                className="w-full"
                value={filterParam}
                onChange={(e) => setFilterParam(e.target.value)}
                placeholder="Nome do Beneficiario"
                onKeyDown={(e) => handleSearch(e.keyCode)}
              />
            </div>
          )}

          {(selectedFilter === 'vencimento' || selectedFilter === 'pagamento' || selectedFilter === 'repasse') && (
            <div className="w-full md:w-fit flex flex-col md:flex-row gap-1">
              <div className="w-full md:w-56">
                <Calendar
                  pt={CalendarPague}
                  className="formularioAdimplencia"
                  placeholder="Inicio do Período"
                  dateFormat="dd/mm/yy"
                  value={filterTimeStart}
                  onChange={(e) => {
                    setFilterTimeStart(e.value);
                  }}
                  maxDate={filterTimeEnd}
                  showIcon
                  icon={
                    <FaCalendarAlt
                      className={classNames(
                        'w-[3rem] h-[3rem] p-3 rounded-r-lg',
                        'bg-sky-400 text-white hover:bg-sky-500',
                        'dark:bg-sky-500 dark:text-black dark:hover:bg-sky-400'
                      )}
                    />
                  }
                />
              </div>
              <div className="w-full md:w-56">
                <Calendar
                  pt={CalendarPague}
                  className="formularioAdimplencia"
                  placeholder="Fim do Período"
                  dateFormat="dd/mm/yy"
                  value={filterTimeEnd}
                  onChange={(e) => {
                    setFilterTimeEnd(e.value);
                  }}
                  minDate={filterTimeStart}
                  showIcon
                  icon={
                    <FaCalendarAlt
                      className={classNames(
                        'w-[3rem] h-[3rem] p-3 rounded-r-lg',
                        'bg-sky-400 text-white hover:bg-sky-500',
                        'dark:bg-sky-500 dark:text-black dark:hover:bg-sky-400'
                      )}
                    />
                  }
                />
              </div>
            </div>
          )}

          <div className="w-full md:w-fit flex flex-col md:flex-row">
            <Button
              label="Status"
              icon={
                iconStatus ? (
                  <FaAngleDown style={{ marginTop: '2px' }} />
                ) : (
                  <FaTimes style={{ marginTop: '2px' }} />
                )
              }
              onClick={(e) => {
                op.current.toggle(e);
              }}
              badge={statusParams.length || '0'}
              pt={{
                root: ({ props, context }) => ({
                  className: classNames(
                    'w-40',
                    'items-center cursor-pointer inline-flex overflow-hidden relative select-none text-center align-bottom',
                    'transition duration-200 ease-in-out',
                    'focus:outline-none focus:outline-offset-0',
                    {
                      'text-white dark:text-gray-900 bg-blue-500 dark:bg-blue-400 border border-blue-500 dark:border-blue-400 hover:bg-blue-600 dark:hover:bg-blue-500 hover:border-blue-600 dark:hover:border-blue-500 focus:shadow-[0_0_0_2px_rgba(255,255,255,1),0_0_0_4px_rgba(157,193,251,1),0_1px_2px_0_rgba(0,0,0,1)] dark:focus:shadow-[0_0_0_2px_rgba(28,33,39,1),0_0_0_4px_rgba(147,197,253,0.7),0_1px_2px_0_rgba(0,0,0,0)]':
                        !props.link && props.severity === null && !props.text && !props.outlined && !props.plain,
                      'text-blue-600 bg-transparent border-transparent focus:shadow-[0_0_0_2px_rgba(255,255,255,1),0_0_0_4px_rgba(157,193,251,1),0_1px_2px_0_rgba(0,0,0,1)] dark:focus:shadow-[0_0_0_2px_rgba(28,33,39,1),0_0_0_4px_rgba(147,197,253,0.7),0_1px_2px_0_rgba(0,0,0,0)]':
                      props.link
                    },
                    { 'shadow-lg': props.raised },
                    { 'rounded-md': !props.rounded, 'rounded-full': props.rounded },
                    { 'shadow-lg': props.raised && props.text },
                    {
                      'text-gray-500 hover:bg-gray-300/20': props.plain && props.text,
                      'text-gray-500 border border-gray-500 hover:bg-gray-300/20': props.plain && props.outlined,
                      'text-white bg-gray-500 border border-gray-500 hover:bg-gray-600 hover:border-gray-600': props.plain && !props.outlined && !props.text
                    },
                    { 'px-4 py-3 text-base': props.size === null, 'text-xs py-2 px-3': props.size === 'small', 'text-xl py-3 px-4': props.size === 'large' },
                    { 'flex-column': props.iconPos == 'top' || props.iconPos == 'bottom' },
                    { 'opacity-60 pointer-events-none cursor-default': context.disabled }
                  )
                }),
                label: ({ props }) => ({
                  className: classNames(
                    'w-[4.9rem]',
                    'duration-200',
                    'font-bold',
                    {
                      'hover:underline': props.link
                    },
                    { 'invisible w-0': props.label == null }
                  )
                }),
                badge: ({ props }) => ({
                  className: classNames({ 'ml-2 w-4 h-4 leading-none flex items-center justify-center': props.badge })
                })
              }}
            />
          </div>

          <div className="flex flex-row gap-1 justify-around w-full md:w-fit">
            <Button
              pt={{
                root: `hover:dark:bg-green-500 hover:bg-green-600 
                  dark:bg-green-400 bg-green-500 
                  p-3 rounded-md
                  flex justify-center items-center
                  h-[3rem] w-[3rem]
                  text-white dark:text-black transition duration-300`,
                label: 'absolute'
              }}
              icon={<FaSearch className="text-xl" />}
              onClick={() => handleSearch(13)}
            />
            <Button
              pt={{
                root: `hover:dark:bg-red-500 hover:bg-red-600 
                  dark:bg-red-400 bg-red-500 p-3 rounded-md
                  flex justify-center items-center
                  h-[3rem] w-[3rem]
                  text-white dark:text-black transition duration-300`,
                label: 'absolute'
              }}
              icon={<FaTimes className="text-2xl" />}
              onClick={() => {
                setFilterParam('');
                setFilterTimeEnd('');
                setFilterTimeStart('');
                setStatusParams([]);
                setReloading((prevReload) => !prevReload);
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );

  /**
   * Formata moeda BRL.
   *
   * @param {number|string} value
   * @returns {string}
   */
  const formatCurrency = (value) => {
    return Number(value).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  };

  /**
   * Formata data para dd/MM/yyyy.
   *
   * @param {string} e
   * @returns {string}
   */
  const sentDateTemplateValidate = (e) => {
    if (e !== '') {
      return format(addHours(new Date(e), 4), 'dd/MM/yyyy');
    }
    return '-';
  };

  /**
   * Render do status do boleto.
   *
   * @param {any} e
   * @returns {JSX.Element}
   */
  const statusBoleto = (e) => {
    let type;
    const situacao = [e.boleto_situacao];

    if (e.boleto_situacao === 'vencido') type = 'bg-red-300 text-red-700';
    else if (e.boleto_situacao === 'aguardando') type = 'bg-sky-200 text-sky-600';
    else if (e.boleto_situacao === 'pago' || e.boleto_situacao === 'pago(cliente)') type = 'bg-emerald-300 text-emerald-800';
    else if (e.boleto_situacao === 'cancelado') type = 'bg-yellow-200 text-yellow-800';

    if (e.boleto_situacao === 'inadimplencia') {
      switch ((e.faturamento_situacao || '').toUpperCase()) {
        case 'EM PROCESSAMENTO':
          type = 'bg-sky-200 text-sky-600';
          situacao.push(e.faturamento_situacao);
          break;
        case 'PAGO':
        case 'PAGO (CLIENTE)':
          type = 'bg-emerald-300 text-emerald-800';
          situacao.push(e.faturamento_situacao);
          break;
        case 'EM ABERTO':
          situacao.push(e.faturamento_situacao);
        // eslint-disable-next-line no-fallthrough
        default:
          type = 'bg-yellow-200 text-yellow-800';
          break;
      }
    }

    return (
      <div className="flex justify-center items-center">
        <span className={classNames('text-nowrap py-1 px-2 justify-center flex flex-col w-auto', type)}>
          {situacao.map((item) => (
            <p key={item} className="uppercase text-sm font-bold">
              {item}
            </p>
          ))}
        </span>
      </div>
    );
  };

  /**
   * Converte um base64 em um Blob de PDF.
   *
   * @param {string} data - Base64 no formato data:application/pdf;base64,...
   * @returns {Blob} - Blob do tipo application/pdf
   */
  const base64toBlob = (data) => {
    const pdfContentType = 'application/pdf';
    const base64WithoutPrefix = data.substring(`data:${pdfContentType};base64,`.length);

    const byteCharacters = atob(base64WithoutPrefix);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    return new window.Blob([byteArray], { type: pdfContentType });
  };

  /**
   * Template do botão de ações por linha.
   * Menu é único e configurado no clique.
   *
   * @param {any} rowData
   * @returns {JSX.Element}
   */
  const actionTemplate = (rowData) => {
    return (
      <Button
        pt={{
          root: `hover:dark:bg-emerald-300 hover:bg-green-600 
            dark:bg-emerald-500 bg-green-500
            h-10 w-10 rounded-full
            flex justify-center items-center
            text-white dark:text-gray-900 
            transition duration-300`,
          label: 'absolute'
        }}
        icon={<GiCog className="text-2xl" />}
        onClick={(e) => {
          setRowCurrent(rowData);
          setMenuItems(buildMenuItems(rowData));
          menuRef.current?.toggle(e);
        }}
      />
    );
  };

  const footer = (
    <div className="flex justify-center">
      <Button
        severity="success"
        icon="pi pi-send"
        label="Confirmo"
        onClick={() => {
          enviarBaixaManual();
        }}
        loading={isLoading}
      />
    </div>
  );

  const gerando = (
    <div className="flex justify-center">
      <Button
        severity="success"
        icon="pi pi-send"
        label="Confirmo"
        onClick={() => {
          gerarNovoBoleto();
        }}
        loading={isLoading}
      />
    </div>
  );

  /**
   * Template de arquivo no FileUpload.
   *
   * @param {any} file
   * @param {any} props
   * @returns {JSX.Element}
   */
  const itemTemplate = (file, props) => {
    const onTemplateRemove = (f, callback) => {
      setTotalSize(totalSize - f.size);
      callback();
    };

    return (
      <div className="grid justify-between items-center" style={{ marginBottom: '-2rem' }}>
        <div className="p-d-flex p-ai-center" style={{ width: '40%' }}>
          <img alt={file.name} role="presentation" src={file.objectURL} width={100} />
          <span className="p-d-flex p-dir-col p-text-left p-ml-3">
            <b>{file.name}</b>
          </span>
        </div>

        <Tag value={props.formatSize} severity="warning" className="p-px-3 p-py-2" style={{ width: '8vw', height: '5vh' }} />

        <Button
          type="button"
          icon="pi pi-times"
          className="p-ml-auto"
          severity="danger"
          onClick={() => onTemplateRemove(file, props.onRemove)}
          style={{ width: '2vw', height: '4vh' }}
          outlined
          rounded
        />
      </div>
    );
  };

  return (
    <>
      {/* Menu ÚNICO (não por linha) */}
      <Menu
        model={menuItems}
        popup
        ref={menuRef}
        pt={{
          root: 'py-1 bg-white dark:bg-gray-900 text-gray-700 dark:text-white/80 border border-gray-300 dark:border-blue-900/40 rounded-md w-60',
          menu: { className: classNames('m-0 p-0 list-none', 'outline-none') },
          separator: 'border-t border-gray-300 dark:border-blue-900/40 my-1',
          transition: TRANSITIONS.overlay
        }}
      />

      <OverlayPanel ref={op} onShow={() => setIconStatus((prev) => !prev)} onHide={() => setIconStatus((prev) => !prev)}>
        <div className="grid gap-2">
          <div className="flex flex-row gap-1">
            <Checkbox value="pago" onChange={onStatusChange} checked={statusParams.includes('pago')} />
            <label> Pago </label>
          </div>
          <div className="flex flex-row gap-1">
            <Checkbox value="aguardando" onChange={onStatusChange} checked={statusParams.includes('aguardando')} />
            <label> Em Aberto </label>
          </div>
          <div className="flex flex-row gap-1">
            <Checkbox value="cancelado" onChange={onStatusChange} checked={statusParams.includes('cancelado')} />
            <label> Cancelado </label>
          </div>
          <div className="flex flex-row gap-1">
            <Checkbox value="vencido" onChange={onStatusChange} checked={statusParams.includes('vencido')} />
            <label> Vencido </label>
          </div>
          <div className="flex flex-row gap-1">
            <Checkbox value="inadimplencia" onChange={onStatusChange} checked={statusParams.includes('inadimplencia')} />
            <label> Inadimplência </label>
          </div>
          <div className="flex flex-row gap-1">
            <Checkbox value="pago(cliente)" onChange={onStatusChange} checked={statusParams.includes('pago(cliente)')} />
            <label> Pago(cliente) </label>
          </div>
        </div>
      </OverlayPanel>

      <AppCard className="!p-0">
        <div className="grid w-full">
          <DataTable
            header={negotiationTableHeader}
            value={negotiationData}
            totalRecords={totalNegotiation}
            first={first}
            rows={rows}
            rowsPerPageOptions={rowsPerPageOptions}
            onPage={onPage}
            loading={loading}
            scrollable={mobile}
            pt={LargeTablePague}
            dataKey="boleto_recorrencia_id"
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Exibindo {first} de {last} do total de {totalRecords}"
            breakpoint="480px"
            emptyMessage="Nenhum boleto encontrado. "
            paginator
            lazy
          >
            <Column
              headerStyle={{ width: '1rem', textAlign: 'center' }}
              header="Boleto"
              style={{ width: '1rem', itemAlign: 'center', justifyContent: 'center', fontSize: '95%' }}
              body={(rowData) => actionTemplate(rowData)}
            />
            <Column style={{ width: '5rem', textAlign: 'center' }} header="Status" body={statusBoleto} />
            <Column style={{ width: '5rem', fontSize: '90%' }} field="contratante_numero" header="Nº Cliente" />
            <Column style={{ width: '15rem', fontSize: '90%' }} field="usuario_nome" header="Cliente" />
            <Column style={{ width: '15rem', fontSize: '90%' }} field="beneficiario" header="Beneficiario" />
            <Column
              style={{ width: '5rem', fontSize: '90%' }}
              field="faturamento_descricao"
              header="Descrição"
              body={({ faturamento_descricao }) => faturamento_descricao}
            />
            <Column
              style={{ width: '5rem', textAlign: 'right', fontSize: '90%' }}
              field="rec_contratante_valor"
              header="Valor"
              body={(rowData) => formatCurrency(rowData.boleto_valor)}
            />
            <Column
              style={{ width: '5rem', textAlign: 'right', fontSize: '90%' }}
              field="rec_contratante_desconto"
              header="Desconto"
              body={(rowData) => formatCurrency(rowData.faturamento_desconto)}
            />
            <Column
              style={{ width: '5rem', textAlign: 'left', fontSize: '90%' }}
              field="boleto_vencimento"
              header="Vencimento"
              body={(rowData) => sentDateTemplateValidate(rowData.boleto_vencimento)}
            />
            <Column
              style={{ width: '5rem', textAlign: 'center', fontSize: '90%' }}
              field="boleto_valor_pago"
              header="Valor pago"
              body={({ boleto_valor_pago }) => formatCurrency(boleto_valor_pago)}
            />
          </DataTable>
        </div>
      </AppCard>

      {showConfirm && (
        <Dialog
          header="Confirme os dados antes de enviar"
          onHide={() => {
            setShowConfirm(false);
          }}
          visible
          style={{
            minHeigth: '30vw',
            minWidth: '60vw'
          }}
          footer={footer}
        >
          <div className="flex p-3 md:justify-between md:text-left text-center">
            <div className="w-full md:w-7/12 mt-4">
              <h5>
                <b>Descrição: </b>
                {baixaDescricao}
              </h5>
              <h5>
                <b>Valor: </b>
                {formatCurrency(valorBaixa)}
              </h5>
              <h5>
                <b>Data pagamento: </b>
                {format(baixaDataPagamento, 'dd/MM/yyyy')}
              </h5>
              <h5>
                <b>Tipo de pagamento: </b>
                {listarTipoId[1]}
              </h5>
            </div>
            <div className="w-full md:w-1/3">
              <i className="pi pi-plus-circle p-mr-3 ml-2 mt-4" style={{ textAlign: 'center', color: '#326fd1', fontSize: '9rem' }} />
            </div>
          </div>
        </Dialog>
      )}

      {showGerar && (
        <Dialog
          header="Confirme as mudanças para o novo boleto"
          onHide={() => setShowGerar(false)}
          visible
          style={{ minHeight: '30vw', minWidth: '30vw' }}
          footer={gerando}
        >
          <PreviewBoletoConfirmacao
            descricao={boletoDescricao}
            novoVencimento={boletoVencimento}
            valorBase={rowCurrent?.boleto_valor}
            novoValor={boletoValor}
            novoDesconto={parseFloat(boletoDesconto ?? 0)}
            aplicarMulta={boletoMulta}
            aplicarJuros={boletoJuros}
            multaPercentual={rowCurrent?.cre_parametro_multa ?? 2}
            jurosPercentual={rowCurrent?.cre_parametro_juros ?? 1}
            vencimentoOriginal={rowCurrent?.boleto_vencimento}
          />
        </Dialog>
      )}

      {showDelete && (
        <ConfirmDialog
          header="Deseja mesmo cancelar esté boleto?"
          visible
          onHide={() => setShowDelete(false)}
          acceptClassName="outline-green-500 hover:outline-green-600 outline-2 outline bg-green-500 hover:bg-green-600 rounded-md w-full p-3 text-white transition duration-300"
          rejectClassName="outline-red-500 outline-2 outline rounded-md text-red-500 hover:bg-red-500 w-full p-3 hover:text-white transition duration-300"
          acceptLabel="Cancelar"
          rejectLabel="Não Cancelar"
          acceptIcon={<FaCheck />}
          rejectIcon={<FaTimes />}
          accept={() => cancelaBoleto()}
          reject={() => setShowDelete(false)}
          footer={confirmFooter}
        />
      )}

      {showExportXLS && (
        <ExportarParaXLS
          close={() => setShowExportXLS(false)}
          data={negotiationData}
          dataTotal={totalNegotiation}
          searchData={{
            credor_id: credorData.credor_id,
            selectedFilter,
            filterParam,
            recebivelTipoId,
            avulsoTipoId,
            filterTimeStart,
            filterTimeEnd
          }}
        />
      )}

      {showExportPDF && (
        <ExportarParaPDF
          close={() => setShowExportPDF(false)}
          data={negotiationData}
          dataTotal={totalNegotiation}
          searchData={{
            credor_id: credorData.credor_id,
            selectedFilter,
            filterParam,
            recebivelTipoId,
            avulsoTipoId,
            filterTimeStart,
            filterTimeEnd
          }}
        />
      )}

      {showCancel && (
        <Dialog
          header="Cancelar boleto..."
          onHide={() => setShowCancel(false)}
          pt={{
            root: {
              className: 'w-full lg:w-1/3 sm:w-2/3 '
            }
          }}
          visible
        >
          <form onSubmit={(e) => handleDelete(e)}>
            <div className="">
              <div className="w-full flex flex-col">
                <label htmlFor="boleto_cancel" className="mt-2 mb-2">
                  Descreva o motivo do cancelamento
                </label>
                <InputText
                  id="boleto_cancel"
                  placeholder="ex: motivo do cancelamento"
                  value={cancelaDescricao}
                  onChange={(e) => setCancelaDescricao(e.target.value)}
                  type="text"
                  required
                />
                <div className="w-full flex items-center justify-center">
                  <div className="w-full mt-2 sm:w-2/3 md:w-1/3">
                    <Button
                      className="w-full"
                      label="Cancelar"
                      type="submit"
                      severity="warning"
                      icon={<FaTrash />}
                      loading={isLoading}
                    />
                  </div>
                </div>
              </div>
            </div>
          </form>
        </Dialog>
      )}

      {showBaixaManual && (
        <Dialog
          header="Baixa manual"
          pt={{
            root: {
              className: 'lg:w-6/12 md:w-8/12 w-full h-screen md:max-h-[85%] overflow-y-scroll'
            }
          }}
          onHide={() => {
            setShowBaixaManual(false);
            setListaTipo([]);
          }}
          onShow={() => {
            listarPagamentoTipo();
            setBaixaDescricao('');
            setValorBaixa('');
            setListarTipoId('');
            setBaixaDataPagamento('');
            setBaixaManualImagem('');
          }}
          visible
        >
          <form onSubmit={(e) => handleSubmit(e)}>
            <div className="flex flex-col justify-between p-3 gap-4">
              <div className="flex flex-col md:flex-row gap-4">
                <div className="w-full md:w-1/2 flex flex-col">
                  <label htmlFor="boletoBaixaDescrição" className="mt-2 mb-2">
                    Descrição
                  </label>
                  <InputText
                    id="boletoBaixaDescrição"
                    placeholder="ex: Pago pela empresa"
                    value={baixaDescricao}
                    onChange={(e) => setBaixaDescricao(e.target.value)}
                    type="text"
                    required
                  />

                  <label htmlFor="valor_pago" className="mt-2 mb-2">
                    Valor pago R$
                  </label>
                  <InputText
                    id="valor_pago"
                    placeholder="ex: 1999,91"
                    value={valorBaixa}
                    onChange={(e) => setValorBaixa(e.target.value)}
                    type="number"
                    required
                  />

                  <label htmlFor="forma_de_pagamento" className="mt-2 mb-2">
                    Forma de pagamento
                  </label>
                  <Dropdown
                    id="forma_de_pagamento"
                    name="forma_de_pagamento"
                    style={{ width: '100%' }}
                    placeholder="Selecione"
                    options={listaTipo}
                    value={listarTipoId}
                    onChange={(e) => {
                      setListarTipoId(e.value);
                    }}
                  />

                  <label htmlFor="data_pagamento" className="mt-2 mb-2">
                    Data pagamento
                  </label>
                  <Calendar
                    id="data_pagamento"
                    locale="pt-BR"
                    className="formularioAdimplencia"
                    pt={CalendarPague}
                    icon={
                      <FaCalendarAlt
                        className={classNames(
                          'px-4 rounded-r-lg',
                          'w-[50px] h-full',
                          'bg-sky-400 text-white hover:bg-sky-500',
                          'dark:bg-sky-500 dark:text-black dark:hover:bg-sky-400'
                        )}
                      />
                    }
                    dateFormat="dd/mm/yy"
                    value={baixaDataPagamento}
                    onChange={(e) => setBaixaDataPagamento(e.value)}
                    placeholder="ex: 25/05/2022"
                    yearRange="2022:2030"
                    maxDate={addHours(new Date(), 3)}
                    showOnFocus={false}
                    showIcon
                    required
                    mask="99/99/9999"
                  />
                </div>

                <div className="w-full md:w-1/2 flex flex-col">
                  <label htmlFor="pagamento_imagem" className="mt-2 mb-2">
                    Comprovante de pagamento
                  </label>
                  <FileUpload
                    id="pagamento_imagem"
                    name="file"
                    chooseLabel="Carregar imagem ou pdf"
                    accept=".png, .jpeg, .jpg, .jpe, application/pdf"
                    customUpload
                    auto
                    itemTemplate={itemTemplate}
                    uploadHandler={uploadImagem}
                    onRemove={() => setBaixaManualImagem({})}
                    maxFileSize={TRES_MB_EM_BYTES}
                    invalidFileSizeMessageSummary="Tamanho inválido"
                    invalidFileSizeMessageDetail="Sua imagem passou o limite de 3MB"
                  />
                  <label htmlFor="pagamento_imagem" className="mt-2 mb-2">
                    <b>( Tamanho maximo 3Mb )</b>
                  </label>
                </div>
              </div>

              <div className="w-full flex items-center justify-center">
                <div className="w-full mt-2 md:w-2/3 lg:w-1/3">
                  <Button
                    className="w-full"
                    label="Enviar"
                    type="submit"
                    severity="success"
                    icon={<FaShare />}
                    loading={isLoading}
                  />
                </div>
              </div>
            </div>
          </form>
        </Dialog>
      )}

      {showGerarNovo && (
        <Dialog
          header="Atualizar Boleto"
          pt={{
            root: {
              className: 'lg:w-6/12 md:w-8/12 w-full h-screen md:max-h-[85%] overflow-y-scroll'
            }
          }}
          onHide={() => {
            setShowGerarNovo(false);
            setBoletoContrato('');
            setBoletoContratante('');
            setboletoDescricao('');
            setBoletoValor(0);
            setBoletoDesconto(0);
            setBoletoVencido('');
            setBoletoMulta(true);
            setBoletoJuros(true);
            setBoletoVencimento('');
            setBoletoPago('');
          }}
          onShow={() => {
            setBoletoContrato(rowCurrent?.contrato_numero ?? '');
            setBoletoContratante(rowCurrent?.usuario_nome ?? '');
            setboletoDescricao(rowCurrent?.faturamento_descricao ?? '');
            setBoletoValor(rowCurrent?.boleto_valor ?? 0);
            setBoletoDesconto(rowCurrent?.faturamento_desconto ?? 0);
            setBoletoVencido(rowCurrent?.boleto_vencimento_br ?? '');
            setBoletoPago(rowCurrent?.boleto_valor_pago);
          }}
          visible
        >
          <form onSubmit={(e) => handleRenew(e)}>
            <div className="flex flex-col justify-between p-3 gap-4">
              <div className="flex flex-col md:flex-row gap-4">
                <div className="w-full md:w-1/2 flex flex-col ">
                  <label htmlFor="boleto_contrato" className="mt-2 mb-2">
                    Numero do Contrato
                  </label>
                  <InputText id="boleto_contrato" value={boletoContrato} type="text" required disabled />

                  <label htmlFor="boleto_contratante" className="mt-2 mb-2">
                    Contratante
                  </label>
                  <InputText id="boleto_contratante" value={boletoContratante} type="text" required disabled />

                  <label htmlFor="boleto_descricao" className="mt-2 mb-2">
                    Descrição
                  </label>
                  <InputText id="boleto_descricao" value={boletoDescricao} type="text" required disabled />

                  <label htmlFor="boleto_vencido" className="mt-2 mb-2">
                    Vencido dia
                  </label>
                  <InputText id="boleto_vencido" value={boletoVencido} type="text" required disabled />
                </div>

                <div className="w-full md:w-1/2 flex flex-col ">
                  <label htmlFor="boleto_valor" className="my-2">
                    Valor
                  </label>
                  <InputNumber
                    id="boleto_valor"
                    placeholder="ex: 1999,91"
                    pt={InputNumberPague}
                    value={boletoValor}
                    onChange={(e) => setBoletoValor(e.value)}
                    prefix="R$"
                    minFractionDigits={0}
                    maxFractionDigits={2}
                    required
                  />

                  <label htmlFor="boleto_desconto" className="my-2">
                    Desconto
                  </label>
                  <InputNumber
                    id="boleto_desconto"
                    placeholder="ex: 1999,91"
                    value={boletoDesconto}
                    pt={InputNumberPague}
                    onChange={(e) => setBoletoDesconto(e.value)}
                    mode="decimal"
                    minFractionDigits={0}
                    maxFractionDigits={2}
                    required
                  />

                  <label className="my-2">Cobranças extras</label>
                  <div className="flex text-center items-center gap-4" style={{ margin: '11px 0px' }}>
                    <div className="flex gap-2">
                      <label htmlFor="boleto_multa">Multa</label>
                      <InputSwitch id="boleto_multa" checked={boletoMulta} onChange={(e) => setBoletoMulta(e.value)} />
                    </div>
                    <div className="flex gap-2">
                      <label htmlFor="boleto_juros">Juros</label>
                      <InputSwitch id="boleto_juros" checked={boletoJuros} onChange={(e) => setBoletoJuros(e.value)} />
                    </div>
                  </div>

                  <label htmlFor="boleto_vencimento" className="my-2">
                    Novo vencimento
                  </label>
                  <Calendar
                    id="boleto_vencimento"
                    locale="pt-BR"
                    dateFormat="dd/mm/yy"
                    value={boletoVencimento}
                    className="formularioAdimplencia"
                    pt={CalendarPague}
                    icon={
                      <FaCalendarAlt
                        className={classNames(
                          'px-4 rounded-r-lg',
                          'w-[50px] h-full',
                          'bg-sky-400 text-white hover:bg-sky-500',
                          'dark:bg-sky-500 dark:text-black dark:hover:bg-sky-400'
                        )}
                      />
                    }
                    onChange={(e) => setBoletoVencimento(e.value)}
                    placeholder="ex: 25/05/2022"
                    yearRange="2022:2030"
                    minDate={addHours(new Date(), 3)}
                    showOnFocus={false}
                    showIcon
                    required
                    mask="99/99/9999"
                  />
                </div>
              </div>

              <div className="w-full flex center justify-center">
                <div className="w-full mt-2 md:w-2/3 lg:w-1/3">
                  <Button
                    className="w-full"
                    label="Atualizar Boleto"
                    type="submit"
                    severity="success"
                    icon={<FaUndo className="mr-2" />}
                    loading={isLoading}
                  />
                </div>
              </div>
            </div>
          </form>
        </Dialog>
      )}
    </>
  );
};
